export default __webpack_public_path__ + "static/media/back-to-school-text.ca57c954.png";